export default __webpack_public_path__ + "static/media/onboarding_step3.8e0014cb.svg";